import { isString } from '../isString/isString.js';
import { isUndefined } from '../isUndefined/isUndefined.js';
import { storage } from '../storage/storage.js';
import { STORAGE_KEY } from './storage-key.js';
import { subscriptionStyles, isSubscription, commonStyle } from './subscriptions.js';

var _a;
let SUBSCRIPTIONS_CACHE;
const getSubscriptions = () => {
  if (isUndefined(SUBSCRIPTIONS_CACHE)) {
    const storedSubscriptions = storage.local.get(STORAGE_KEY);
    if (isString(storedSubscriptions)) {
      SUBSCRIPTIONS_CACHE = new Set(
        storedSubscriptions.split(",").filter(isSubscription)
      );
    } else {
      SUBSCRIPTIONS_CACHE = /* @__PURE__ */ new Set();
    }
  }
  return SUBSCRIPTIONS_CACHE;
};
const subscribeTo = (subscription) => {
  const subscriptions = getSubscriptions();
  subscriptions.add(subscription);
  storage.local.set(STORAGE_KEY, Array.from(subscriptions).join(","));
  log(subscription, "\u{1F514} Subscribed, hello!");
};
const unsubscribeFrom = (subscription) => {
  const subscriptions = getSubscriptions();
  subscriptions.delete(subscription);
  storage.local.set(STORAGE_KEY, Array.from(subscriptions).join(","));
  log(subscription, "\u{1F515} Unsubscribed, good-bye!");
};
const isSubscribedTo = (subscription) => getSubscriptions().has(subscription);
const logStyles = { ...subscriptionStyles, ...commonStyle };
const messageStyle = (subscriptionStyle) => {
  const { background, font } = logStyles[subscriptionStyle];
  return `background: ${background}; color: ${font}; padding: 2px 6px; border-radius:20px`;
};
const log = (subscription, ...args) => {
  if (isSubscribedTo(subscription)) {
    const styles = [messageStyle("common"), "", messageStyle(subscription), ""];
    console.log(`%c@guardian%c %c${subscription}%c`, ...styles, ...args);
  }
};
if (typeof window !== "undefined") {
  window.guardian || (window.guardian = {});
  (_a = window.guardian).logger || (_a.logger = {
    subscribeTo,
    unsubscribeFrom,
    teams: () => {
      console.warn(
        "guardian.logger.teams() is deprecated - use subscriptions()"
      );
      return Object.keys(subscriptionStyles);
    },
    subscriptions: () => Object.keys(subscriptionStyles)
  });
}

export { isSubscribedTo, log, messageStyle };
